export const YoutubeIcon = ({
  width = 24,
  height = 24,
  title = "Youtube",
  ...rest
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 24 24"
      {...rest}>
      <title>{title}</title>
      <path
        fill="#F5F6F7"
        d="M11.987 3.73s7.52 0 9.384.505a2.94 2.94 0 0 1 2.116 2.094C24 8.15 24 11.99 24 11.99c0 .022-.002 3.87-.513 5.702a3 3 0 0 1-2.116 2.094c-1.865.497-9.384.496-9.384.496-.034 0-7.506 0-9.358-.496a3.08 3.08 0 0 1-2.133-2.094C.002 15.86 0 12.012 0 11.99c0 0 0-3.84.496-5.66A3.02 3.02 0 0 1 2.63 4.234c1.852-.503 9.324-.505 9.358-.505m-2.47 11.793 6.208-3.516-6.207-3.518z"></path>
    </svg>
  );
};
